import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { Box, Button, Collapse, List, styled } from "@mui/material";
import { ReactElement, ReactNode, useState } from "react";

import theme, { palette } from "~frontend/theme";

import { FlexBox } from "../FlexBox";

export const ThreadListContainer = styled(Box)({
  height: "100%",
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  padding: 0,
});

export const ThreadSplitView = styled("div")({
  display: "flex",
  flexDirection: "row",
  flex: 1,
});

export const ThreadListPane = styled("div")({
  width: "450px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: palette.white,
  borderRight: `1px solid ${palette.midGray}`,
});

export const ThreadDisplayPane = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

export const ThreadListWrapper = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: "16px 16px 0",

  "& .MuiTablePagination-root": {
    "& .MuiTablePagination-toolbar": {
      padding: 0,
    },

    "& .MuiTablePagination-input": {
      marginLeft: 0,
      marginRight: "24px",
    },

    "& .MuiSelect-select": {
      fontSize: "12px",
      marginTop: "4px",
    },

    "& .MuiTablePagination-actions": {
      marginLeft: "8px",
    },
  },
});

export const ThreadListItems = styled(List)({
  flex: "1 1 auto",
  overflowY: "auto",
  // height: 0 causes flexbox to calculate the height, and then overflowY: auto
  // will make it scrollable (https://stackoverflow.com/a/14964944)
  height: 0,
});

export const ThreadDetailsWrapper = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  position: "relative",
});

export function ThreadListCollapse({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [listOpen, setListOpen] = useState(true);

  return (
    <>
      <Collapse
        in={listOpen}
        sx={{
          display: "flex",
          // This flex needs to be added to be here because its
          // children are expecting it.
          "& .MuiCollapse-wrapperInner": { display: "flex" },
        }}
        orientation="horizontal"
      >
        {children}
      </Collapse>
      <FlexBox direction="column" justifyContent="flex-start" sx={{ width: 0 }}>
        <Button
          onClick={() => setListOpen(!listOpen)}
          sx={{
            width: "14px",
            height: listOpen ? "40px" : "110px",
            marginTop: listOpen ? theme.spacing(7) : theme.spacing(2.625),
            zIndex: 50,
            minWidth: 0,
            color: palette.darkGray,
            backgroundColor: palette.lightestGray,
            transition: "all 0.25s",

            "&:hover": {
              backgroundColor: palette.lightGray,
              height: "110px",
              marginTop: theme.spacing(2.625),
            },
          }}
        >
          {listOpen ? <NavigateBefore /> : <NavigateNext />}
        </Button>
      </FlexBox>
    </>
  );
}
